import { useApiUrl, useQuery } from '@gemini/lux-ds-pms';
import { DevicesApiRoutes } from '../routes/routes';
import { QueryKeyList } from './querykeys';
import { UserOrganizationLocation } from '@interfaces/interfaces';

interface Props {
  enabled?: boolean;
}

export const useGetFhirOrganizationLocations = ({ enabled }: Props) => {
  const baseUrl = useApiUrl(
    DevicesApiRoutes.GetOrganizationLocations,
    'DEVICE_BFF_API_BASE_URL',
  );

  return useQuery<UserOrganizationLocation>(baseUrl || '', {
    enabled: !!enabled && !!baseUrl,
    queryKey: [QueryKeyList.UserOrganizationLocationQueryKey],
  });
};

export default useGetFhirOrganizationLocations;
